import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { CovanceGridColumn } from '../../covance-ag-grid';
import { zcProjectNumberColumn } from '../../documents';
import { buildDateColumn, emailColumn, studyRoleColumn, userNameColumn, countryColumn, getCompositeSiteColumn, activeSiteColumn } from '../../shared';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { SponsorProtocolAccessReport } from './report-types/sponsor-protocol-access-report';
import { SponsorProtocolAccessessStorage } from './sponsor-protocol-accesses-storage';
import { routeData } from '../../shared/route-helpers';

@Component({
    selector: 'sponsor-protocol-access-reports',
    template: require('./sponsor-protocol-access-reports.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorProtocolAccessReportComponent {
    public readonly columnDefs: CovanceGridColumn[];
    public readonly reports$: Observable<SponsorProtocolAccessReport[]>;

    constructor(
        route: ActivatedRoute,
        protocolAccessessStorage: SponsorProtocolAccessessStorage
    ) {
        const selectedStudy$ = route.parent.parent.data.pipe(
            map(x => x[routeData.selectedStudy] as SponsorStudy),
            filter(x => !!x),
            distinctUntilChanged()
        );

        this.columnDefs = this.getColumnDefs();
        this.reports$ = selectedStudy$.pipe(
            switchMap((study) => protocolAccessessStorage.getReports(study.protocolId)),
        );
    }

    private getColumnDefs(): CovanceGridColumn[] {
        const columns: CovanceGridColumn[] = [
            zcProjectNumberColumn,
            getCompositeSiteColumn('asc'),
            countryColumn,
            userNameColumn,
            emailColumn,
            studyRoleColumn,
            buildDateColumn<SponsorProtocolAccessReport, 'accountCreatedDate'>('accountCreatedDate', 'Account Created Date', 'desc'),
            buildDateColumn<SponsorProtocolAccessReport, 'accessGivenDate'>('accessGivenDate', 'Access Given Date', 'desc'),
            buildDateColumn<SponsorProtocolAccessReport, 'accessRevokedDate'>('accessRevokedDate', 'Access Revoked Date'),
            buildDateColumn<SponsorProtocolAccessReport, 'lastAccessDate'>('lastAccessDate', 'Last Login Date'),
            activeSiteColumn
        ];

        return columns;
    }
}
